// @flow

import React, { Component } from 'react';
import moment from 'moment';
import styler from 'react-styling';
import _ from 'lodash';
import { Row, Col } from 'react-bootstrap/lib';
import NProgress from 'react-nprogress';

import { EventTable } from '../index';

const style = styler `   
Day
  margin-bottom: 30px

Wrapper
  margin-bottom: 10px

Heading
  color: #666
  font-weight: 500
  background-color: #FFF
  border-bottom: 1px solid #DDD
  padding: 8px 12px
`;

class CalendarTables extends Component {
  componentWillReceiveProps(nextProps: Object) {
    if (nextProps.calendarView === 'listWeek') {
      NProgress.inc(0.2);
      setTimeout(() => {
        NProgress.inc(0.2);
      }, 200);
      setTimeout(() => {
        NProgress.done();
      }, 1000);
    }
  }
  props: {
    languagedata: Object,
    initialContactsSelected: Array<any>,
    startDate: number,
    endDate: number,
    renderEvents: Function,
    calendarView: string,
  }

  enumerateDaysBetweenDates = (startDate: number, endDate: number) => {
    const dates = [];
    const currDate = moment(startDate);
    const lastDate = moment(endDate);

    dates.push(currDate.clone());
    while (currDate.add(1, 'days').diff(lastDate) < 0) {
      dates.push(currDate.clone());
    }

    return dates;
  }

  _renderMultipleTables = (firstRow: Array<moment>, secondRow: Array<moment>, thirdRow: Array<moment>, fourthRow: Array<moment>) => (
    <div style={style.Wrapper}>
      {this.props.renderEvents(this.props.initialContactsSelected, moment.unix(this.props.startDate), moment.unix(this.props.endDate))}
      <Row>
        {firstRow.map((date) =>
          <Col md={6} style={style.Day}>
            <div style={style.Heading}>{date.format('dddd')}</div>
            <EventTable languagedata={this.props.languagedata} date={date} calendarView={this.props.calendarView} />
          </Col>
        )}
      </Row>
      <Row>
        {secondRow.map((date) =>
          <Col md={6} style={style.Day}>
            <div style={style.Heading}>{date.format('dddd')}</div>
            <EventTable languagedata={this.props.languagedata} date={date} calendarView={this.props.calendarView} />
          </Col>
        )}
      </Row>
      <Row>
        {thirdRow.map((date) =>
          <Col md={6} style={style.Day}>
            <div style={style.Heading}>{date.format('dddd')}</div>
            <EventTable languagedata={this.props.languagedata} date={date} calendarView={this.props.calendarView} />
          </Col>
        )}
      </Row>
      <Row>
        {fourthRow.map((date) =>
          <Col md={6} style={style.Day}>
            <div style={style.Heading}>{date.format('dddd')}</div>
            <EventTable languagedata={this.props.languagedata} date={date} calendarView={this.props.calendarView} />
          </Col>
        )}
      </Row>
    </div>
    );

  _renderSingleTable = (date: moment) => (
    <div style={style.Wrapper}>
      <Row>
        <Col md={12} style={style.Day}>
          <div style={style.Heading}>{date.format('dddd')}</div>
          <EventTable languagedata={this.props.languagedata} date={date} calendarView={this.props.calendarView} />
          {this.props.renderEvents(this.props.initialContactsSelected, date.toDate())}
        </Col>
      </Row>
    </div>
  );
  render() {
    const { calendarView } = this.props;
    const enumerateDaysBetweenDates = this.enumerateDaysBetweenDates(moment.unix(this.props.startDate), moment.unix(this.props.endDate));
    const firstRow = _.slice(enumerateDaysBetweenDates, 0, 2);
    const secondRow = _.slice(enumerateDaysBetweenDates, 2, 4);
    const thirdRow = _.slice(enumerateDaysBetweenDates, 4, 6);
    const fourthRow = _.slice(enumerateDaysBetweenDates, 6, 7);
    return (
      <div>
        {calendarView === 'listWeek' ? this._renderMultipleTables(firstRow, secondRow, thirdRow, fourthRow, enumerateDaysBetweenDates) : this._renderSingleTable(enumerateDaysBetweenDates[0]) }
      </div>
    );
  }
}

export default CalendarTables;



// WEBPACK FOOTER //
// ./src/js/Components/Calendar/CalendarTables.js